import { useEffect, useState } from 'react';
export const PROGRESS_DEFAULT_RESET = {
    error: true,
    success: true,
};
const CLASS_NAMES = {
    loading: 'progress-loading',
    notransition: 'notransition',
    success: 'state-success',
    error: 'state-error',
};
const BAR_WIDTH = {
    start: '0',
    end: '100%',
};
const TIMEOUT = {
    removeLoading: 2000,
    finishState: 500,
    removeNoTransition: 250,
};
export const useProgress = (isLoading, hasError, reset, slowFactor, progress, containerRef, barRef) => {
    const [timer, setTimer] = useState(undefined);
    useEffect(() => {
        if (isLoading) {
            let value = 0;
            applyStartState(containerRef.current);
            setTimer(setInterval(() => (value = updateBar(barRef.current, value, progress)), 250 * slowFactor));
        }
        else if (timer) {
            clearInterval(timer);
            setTimer(undefined);
            barRef.current.style.width = BAR_WIDTH.end;
            setTimeout(() => {
                resetBar(barRef.current);
                applyFinishState(!hasError, containerRef.current, reset);
            }, TIMEOUT.finishState);
        }
    }, [isLoading]);
    useEffect(() => () => {
        clearInterval(timer);
        setTimer(undefined);
    }, []);
};
const applyStartState = (element) => {
    element.classList.add(CLASS_NAMES.loading);
    element.disabled = true;
};
const updateBar = (bar, value, progress) => {
    const newValue = progress || value + increment(value);
    if (bar)
        bar.style.width = `${newValue}%`;
    return newValue;
};
const applyFinishState = (isSuccess, element, reset) => {
    const finishClass = isSuccess ? CLASS_NAMES.success : CLASS_NAMES.error;
    element.classList.add(finishClass);
    if ((!reset.error && !isSuccess) || (!reset.success && isSuccess)) {
        return;
    }
    setTimeout(() => {
        element.classList.remove(finishClass, CLASS_NAMES.loading);
        element.disabled = false;
    }, TIMEOUT.removeLoading);
};
const resetBar = (bar) => {
    bar.classList.add(CLASS_NAMES.notransition);
    bar.style.width = BAR_WIDTH.start;
    setTimeout(() => bar.classList.remove(CLASS_NAMES.notransition), TIMEOUT.removeNoTransition);
};
const increment = (stat) => 6.0 * Math.exp(-5.0 * (stat / 100));
